var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75008 5.00004C1.75008 3.57504 2.90841 2.41671 4.33342 2.41671H7.66675V0.833374H4.33342C2.03341 0.833374 0.166748 2.70004 0.166748 5.00004C0.166748 7.30004 2.03341 9.16671 4.33342 9.16671H7.66675V7.58337H4.33342C2.90841 7.58337 1.75008 6.42504 1.75008 5.00004ZM5.16675 5.83337H11.8334V4.16671H5.16675V5.83337ZM12.6667 0.833374H9.33342V2.41671H12.6667C14.0917 2.41671 15.2501 3.57504 15.2501 5.00004C15.2501 6.42504 14.0917 7.58337 12.6667 7.58337H9.33342V9.16671H12.6667C14.9667 9.16671 16.8334 7.30004 16.8334 5.00004C16.8334 2.70004 14.9667 0.833374 12.6667 0.833374Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.97900eaa4ff46bac5c78c51103352985.svg";
export { ForwardRef as ReactComponent };